import CroppedThumbnail from "../../../../../croppedThumbnail/CroppedThumbnail";
import { CropButton } from "../../../../../buttons/iconButtons/index";
import type ImageAspectRatio from "enums/imageAspectRatio";
import { type FC } from "react";

import "./croppedImagePreview.scss";

interface Props {
  thumbnailUrl: string;
  onClick: () => void;
  aspectRatio: ImageAspectRatio;
}

const CroppedImagePreview: FC<Props> = (props) => {
  return (
    <div className="cropped-image-preview" data-testid="cropped-image-preview">
      <CroppedThumbnail {...props}>
        <CropButton isDisabled={false} />
      </CroppedThumbnail>
    </div>
  );
};

export default CroppedImagePreview;
